import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { usePickupPartnerVideoCallMutation as usePickupPartnerVideoCallMutationType } from "@/modules/video-call/services/__generated__/usePickupPartnerVideoCallMutation.graphql"

const pickupPartnerVideoCallMutation = graphql`
  mutation usePickupPartnerVideoCallMutation($input: PickupPartnerVideoCallInput!) {
    pickupPartnerVideoCall(input: $input) {
      startVideoCallOutput {
        roomSid
        sofiaUserToken
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`

const usePickupPartnerVideoCallMutation = () => {
  const [commit, isFlight] = useMutation<usePickupPartnerVideoCallMutationType>(pickupPartnerVideoCallMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<usePickupPartnerVideoCallMutationType>) => {
      commit(config)
    },
    [commit],
  )
  return [commitHandler, isFlight] as const
}

export { usePickupPartnerVideoCallMutation }
